export default "__VITE_ASSET__DiQ8BXW8__"